import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'components/Checkbox';
import { Box } from 'reflexbox';
import './collectedCheckbox.styles.scss';

const CollectedCheckbox = ({ id, checked, onChange }) => (
    <Box className="product__package-checkbox">
        <Checkbox
            id={'collected' + id}
            name={id}
            label="product_location_collected"
            checked={checked}
            onChange={onChange}
            className={'checkbox'}
        />
    </Box>
);

CollectedCheckbox.propTypes = {
    id: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default CollectedCheckbox;
